import PrintInvoiceShipForMe from "../../../pages/shipforme/print/PrintInvoiceShipForMe";

export default {
  title: "الفواتير",
  subtitle: "إدارة الفواتير",
  
  addNew: "إنشاء فاتورة جديدة",
  createInvoice: "إنشاء فاتورة",
  editInvoice: "تعديل الفاتورة",
  deleteInvoice: "حذف الفاتورة",
  PrintInvoice: "طباعة الفاتورة",
  fields: {
    invoiceNumber: "رقم الفاتورة",
    orderNumber: "رقم الطلب",
    customer: "العميل",
    date: "تاريخ الفاتورة",
    dueDate: "تاريخ الاستحقاق",
    status: "الحالة",
    subtotal: "المجموع الفرعي",
    tax: "الضريبة",
    total: "المجموع الكلي",
    notes: "ملاحظات",
    items: "العناصر",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    collectionDate: "تاريخ التحصيل",
    receivedDate: "تاريخ الاستلام",
    isCollected: "حالة التحصيل",
    isReceived: "حالة الاستلام",
    amount: "المبلغ",
    orderId: "رقم الطلب",
    shipForMeId: "رقم اشحنلي",
    externalInvoiceNumber: "رقم إيصال المندوب",
    receivedInvoiceNumber: "رقم إيصال التحصيل",
    paymentGateway: "بوابة الدفع",
    invoiceType: "نوع الفاتورة",
    countryType: "نوع البلد",
    iqd: "دينار"
  },
  
  placeholders: {
    invoiceNumber: "أدخل رقم الفاتورة",
    customer: "اختر العميل",
    date: "اختر تاريخ الفاتورة",
    dueDate: "اختر تاريخ الاستحقاق",
    notes: "أدخل ملاحظات",
    collectionDate: "اختر تاريخ التحصيل",
    receivedDate: "اختر تاريخ الاستلام",
    amount: "أدخل المبلغ",
    externalInvoiceNumber: "أدخل رقم إيصال المندوب",
    receivedInvoiceNumber: "أدخل رقم إيصال التحصيل"
  },
  
  messages: {
    createSuccess: "تم إنشاء الفاتورة بنجاح",
    createError: "فشل في إنشاء الفاتورة",
    updateSuccess: "تم تحديث الفاتورة بنجاح",
    updateError: "فشل في تحديث الفاتورة",
    deleteSuccess: "تم حذف الفاتورة بنجاح",
    deleteError: "فشل في حذف الفاتورة",
    deleteConfirm: "هل أنت متأكد من حذف هذه الفاتورة؟",
    selectAtLeastOne: "يرجى اختيار فاتورة واحدة على الأقل",
    enterInvoiceNumber: "يرجى إدخال رقم الفاتورة",
    bulkUpdateSuccess: "تم تحديث الفواتير بنجاح",
    bulkUpdateError: "فشل في تحديث الفواتير",
    noInvoices: "لا توجد فواتير",
    loadingInvoices: "جاري تحميل الفواتير...",
    fetchError: "فشل في جلب الفواتير"
  },

  // Additional fields
  receiveInvoices: "استلام الفواتير",
  selectedForUpdate: "تم اختيار {{count}} فاتورة للتحديث",
  updateSelected: "تحديث المحدد",

  validation: {
    invoiceNumberRequired: "رقم الفاتورة مطلوب",
    customerRequired: "العميل مطلوب",
    dateRequired: "تاريخ الفاتورة مطلوب",
    dueDateRequired: "تاريخ الاستحقاق مطلوب",
    itemsRequired: "عنصر واحد على الأقل مطلوب"
  },
  
  table: {
    invoiceNumber: "رقم الفاتورة",
    customer: "العميل",
    date: "التاريخ",
    dueDate: "تاريخ الاستحقاق",
    total: "المجموع",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  statusOptions: {
    draft: "مسودة",
    sent: "مرسلة",
    paid: "مدفوعة",
    overdue: "متأخرة",
    cancelled: "ملغية"
  },

  invoiceTypeOptions: {
    in: "داخل",
    out: "خارج"
  },

  // Print Invoice translations
  print: {
    companyLogo: "شعار الشركة",
    consignor: "المرسل:",
    consignee: "المرسل إليه:",
    phone: "الهاتف:",
    date: "التاريخ:",
    invoiceNumber: "رقم الفاتورة:",
    currency: "العملة:",
    paymentGateway: "بوابة الدفع:",
    orderNumber: "رقم الطلب:",

    // Payment status stamps
    status: {
      paid: "مدفوع",
      unpaid: "غير مدفوع",
      cancelled: "ملغي",
      refund: "مسترد"
    },

    // Table headers
    table: {
      description: "الوصف",
      quantity: "الكمية",
      itemPrice: "سعر القطعة",
      totalPrice: "السعر الإجمالي"
    },

    // Information section
    information: "المعلومات:",
    extraServices: "الخدمات الإضافية:",

    // Summary section
    summary: {
      subTotal: "المجموع الفرعي",
      merchantDelivery: "توصيل التاجر",
      serviceCharges: "رسوم الخدمة",
      discount: "الخصم",
      extraServices: "الخدمات الإضافية",
      totalPrice: "السعر الإجمالي",
      totalPaid: "المبلغ المدفوع",
      remaining: "المتبقي",
      dueAmount: "المبلغ المستحق"
    },

    // Footer
    footer: {
      printedBy: "طُبع بواسطة:",
      printedOn: "تاريخ الطباعة:",
      admin: "المدير",
      contactMessage: "إذا كان لديك أي أسئلة حول هذه الفاتورة، يرجى التواصل معنا",
      contactInfo: "متجر 9ar +964 7866601010, info@9arstore.com",
      thankYou: "شكراً لك على تعاملك معنا!"
    },

    // Print button
    printButton: "طباعة / تحميل PDF"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة"
  },
  
  breadcrumbs: {
    invoices: "الفواتير",
    create: "إنشاء فاتورة",
    edit: "تعديل الفاتورة",
    view: "عرض الفاتورة"
  }
};
